<template>
    <div class="packages-component">
        <main id="mainContent" class="padFixBoth">
            <form id="formCrud" class="animated fadeInUp">
                <div class="row ">
                    <div class="col-12 col-md-4 col-xl-3 offset-xl-1">
                        <select v-model="relConsultas.states_id" data-select="on" v-on:change="selectCities($event)" data-name-input="Estado">
                            <option :value="0">Seleccione una Estado</option>
                            <option v-for="state in states" :value="state.id" :key="state.id">
                                {{ state.estado }}
                            </option>
                        </select>
                    </div>
                    <div class="col-12 col-md-4 col-xl-3">
                        <select id="select_cities" v-model="relConsultas.cities_id" data-select="on" data-name-input="Estado">
                            <option :value="0">Selecciona un Ciudad</option>
                            <option v-for="city in cities" :value="city.cities_id" :key="city.cities_id">
                                {{ city.ciudad }}
                            </option>
                        </select>
                    </div>
                    <div class="col-12 col-md-4 col-xl-4">
                        <select v-model="relConsultas.specialty_id" data-select="on" data-name-input="Especialidad">
                            <option :value="0">Selecciona una Especialidad</option>
                            <option v-for="specialty in specialtys" :value="specialty.id" :key="specialty.id">
                                {{ specialty.especialidad }}
                            </option>
                        </select>
                    </div>
                    <div class="col-12 col-md-4 col-xl-3 offset-xl-1">
                        <input id="num-consultas" type="text" v-model="relConsultas.consulta" class="al-inputs scr-input" placeholder="Número de consultas">
                        <label for="num-consultas" class="scr-supertext scr-extra">Número de consultas</label>
                    </div>
                    <div class="col-12 col-md-4 col-xl-3">
                        <button type="button" class="formSubmit" v-on:click="guardar">{{ tituloBtn }}</button>
                    </div>
                </div>
            </form>
            <div class="view">
                <div class="row">
                    <div class="col-12 col-xl-2">
                       <b-pagination pills align="fill" :hide-goto-end-buttons="true" :limit="3" v-model="pagination.current_page" :total-rows="pagination.total" :per-page="pagination.per_page" aria-controls="my-table"   v-on:change="onChange"></b-pagination>
                    </div>
                    <div class="col-12  col-xl-6">
                        <input id="filter-input" class="al-inputs scr-input" v-model="filter" type="search" placeholder="Buscar por palabra">
                        <label for="filter-input" class="scr-supertext scr-extra">Buscar por palabra</label>
                    </div>
                    <div class="col-12 col-xl-2 cont_select">
                        <select id="change_result" class="float" v-model="params.limit" v-on:change="changeLimit">
                            <option :value="10">10</option>
                            <option :value="20">20</option>
                            <option :value="30">30</option>
                            <option :value="50">50</option>
                            <option :value="100">100</option>
                        </select>
                    </div>
                </div>
            </div>
            <b-table responsive id="my-table" striped hover :fields="fields" :busy="isBusy" :filter="filter" :items="pagination.data" show-empty>

                <template #empty="scope">
                    <h4 class="emptyRow">
                        No hay datos para mostrar.
                    </h4>
                </template>
                <template #cell(Estado)="{item}">
                    <span v-if="item.edo"> {{ item.edo['estado'] }}</span>
                    <span v-else>Sin Plan </span>
                </template>
                <template #cell(Ciudad)="{item}">
                    <span v-if="item.city"> {{ item.city['ciudad'] }}</span>
                    <span v-else>Sin Servicio</span>
                </template>
                <template #cell(Especialidad)="data">
                    {{ data.item.specialty['especialidad'] }}
                </template>
                <template #cell(Consultas)="data">
                    {{ data.item.consulta }}
                </template>

                <template #cell(Acciones)="{item}">
                    <div class="dropdown">
                        <button class="btn btn-warning dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <i class="fas fa-cogs"></i>
                        </button>
                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                            <a class="dropdown-item" href="javascript:void(0)" v-on:click="modificar=true; updateReg(item)">Editar</a>
                            <a class="dropdown-item" href="javascript:void(0)" v-on:click="onClickDelete(item.id)">Borrar</a>
                        </div>
                    </div>
                </template>

                <template #table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Loading...</strong>
                    </div>
                </template>

            </b-table>
        </main>
    </div>
</template>
<script>

import {myMixins} from "../mixins/myMixins";
import {estadoService} from "../../Services/States.service";
import {relconsultationspecialtyService} from "../../Services/Relconsultationspecialty.service";
import {specialtysService} from "../../Services/Specialtys.service";
import {statescitiesService} from "../../Services/Statescities.service";

export default {
    name: "Relacion_Servicios_y_Paquetes",
    mixins: [myMixins],
    data() {
        return {
            filter: null,
            showModal: false,
            modificar: false,
            emptytable: false,
            isBusy: false,
            fields: [
                {key: 'Estado'},
                {key: 'Ciudad'},
                {key: 'Especialidad'},
                {key: 'Consultas'},
                {key: 'Acciones'}
            ],
            params: {
                limit: 10,
                page: 1,
                where: []
            },
            pagination: {
                current_page: 1,
                data: [],
                first_page_url: '',
                from: 0,
                last_page: 0,
                last_page_url: '',
                links: [],
                next_page_url: '',
                path: '',
                per_page: 0,
                prev_page_url: '',
                to: 0,
                total: 0,
            },
            relConsultas: {
                id: 0,
                states_id: 0,
                cities_id: 0,
                specialty_id: 0,
                consulta: '',
            },
            states: [],
            cities: [],
            specialtys: [],
            getServArray: [],
            tituloBtn: 'Agregar',
            resp: '',
            currentFilterServ: [],
        }
    },
    methods: {
        async onClickDelete(id) {
            this.resp = await relconsultationspecialtyService.deleteOne(id);
            this.getAlert(this.resp.process, 'delete');
            await this.index();
        },
        updateReg(data = {}) {
            this.modal = 1
            if (this.modificar) {
                this.selectCities(data.states_id);
                this.tituloBtn = 'Actualizar'
                this.relConsultas = data;

            } else {
                this.tituloBtn = 'Agregar';
                this.setEmpty();
            }
        },
        async getData() {
            this.states = await estadoService.getMany();
            this.specialtys = await specialtysService.getMany({limit: 0});
            this.pagination = await relconsultationspecialtyService.getMany(this.params);
        },
        async index() {
            this.isBusy = true;
            await this.getData();
            this.isBusy = false;
        },
        async guardar() {
            //INSERTAR
            let resp = '';
            if (this.modificar) {
                resp = await relconsultationspecialtyService.updateOne(this.relConsultas.id, this.relConsultas);
            } else {
                resp = await relconsultationspecialtyService.saveOne(this.relConsultas);
            }
            //console.log(resp);
            if (resp.process === 'success') {
                this.getAlert(resp.process);
                this.setEmpty();
                await this.index();

            } else {
                this.getAlert(resp.process);
            }

        },
        async onChange(page) {
            this.params.page = page;
            await this.getData();
        },
        async selectCities($e) {
            let state_id = this.stateId($e);
            this.cities = await statescitiesService.getCitiesByState(state_id);
        },
        changeLimit() {
            this.index();
        },
        setEmpty() {
            this.relConsultas = {
                id: 0,
                states_id: 0,
                cities_id: 0,
                specialty_id: 0,
                consulta: 0,
            }
        }
    },
    mounted() {
        this.index();
    },
}
</script>

<style scoped>
#packages-component {
    padding: 0;
    position: relative;
    height: 100%;
    width: 100%;
}
</style>
